<div class="row w-100 pt-3 text-center row-title">
    @if (!active) {
        <div class="bold-text blue-color align-content-center w-100 pb-3">Activation de l'option payante 200
            correspondants
        </div>
    }
    @if (active) {
        <div class="bold-text blue-color align-content-center w-100 pb-3">Désactivation de l'option payante 200
            correspondants
        </div>
    }
</div>
<div class="row w-100 pt-3 text-center">
    <div class="col-12 w-100">
        Je souhaite <span>{{ active ? 'désactiver' : 'activer' }}</span> l'option 200 correspondants supplémentaires sur ma ligne <strong>{{ line.phoneNumber }}</strong>
        <br/>
        @if (!active) {
            <span>
                Cette option vous sera facturée {{ priceDetails?.price }}
                @if (priceDetails?.perMonth) {
                    <span>/mois</span>
                } en plus de votre forfait habituel.
            </span>
        }
        <br/><br/>
    </div>
    <div class="col-12 w-100 cta_container">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
    </div>
</div>
